"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDriveImportStatus = exports.startDriveImport = exports.deleteDriveImportMapping = exports.getDriveImportMapping = exports.getDriveImportMappings = exports.saveDriveImportMapping = exports.AnalyzeDriveImportFile = exports.PreviewDriveImportFile = exports.UploadDriveImportFile = void 0;
var HttpClient_1 = require("../core/HttpClient");
var UploadDriveImportFile = function (school_id, formData) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/drive-import/upload"), formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};
exports.UploadDriveImportFile = UploadDriveImportFile;
var PreviewDriveImportFile = function (school_id, file_id) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/drive-import/preview"), {
        file_id: file_id,
    });
};
exports.PreviewDriveImportFile = PreviewDriveImportFile;
var AnalyzeDriveImportFile = function (school_id, file_id, column_mapping) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/drive-import/analyze"), {
        file_id: file_id,
        column_mapping: column_mapping,
    });
};
exports.AnalyzeDriveImportFile = AnalyzeDriveImportFile;
var saveDriveImportMapping = function (school_id, name, mapping) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/drive-import/mappings"), {
        school_id: school_id,
        name: name,
        mapping: mapping,
    });
};
exports.saveDriveImportMapping = saveDriveImportMapping;
var getDriveImportMappings = function (school_id) {
    return HttpClient_1.HttpClient.get("/schools/".concat(school_id, "/drive-import/mappings"));
};
exports.getDriveImportMappings = getDriveImportMappings;
var getDriveImportMapping = function (school_id, mapping_id) {
    return HttpClient_1.HttpClient.get("/schools/".concat(school_id, "/drive-import/mappings/").concat(mapping_id));
};
exports.getDriveImportMapping = getDriveImportMapping;
var deleteDriveImportMapping = function (school_id, mapping_id) {
    return HttpClient_1.HttpClient.delete("/schools/".concat(school_id, "/drive-import/mappings/").concat(mapping_id));
};
exports.deleteDriveImportMapping = deleteDriveImportMapping;
var startDriveImport = function (school_id, file_id, test, column_mapping, session_type_mapping) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/import-drives"), {
        school_id: school_id,
        file_id: file_id,
        test: test,
        column_mapping: column_mapping,
        session_type_mapping: session_type_mapping,
    });
};
exports.startDriveImport = startDriveImport;
var getDriveImportStatus = function (school_id, import_id) {
    return HttpClient_1.HttpClient.get("/schools/".concat(school_id, "/drive-import/").concat(import_id, "/status"));
};
exports.getDriveImportStatus = getDriveImportStatus;
